const checkMinimumPaymentAmount = (
  sale_outstanding_amount,
  sale_total_amount,
  payment_amount,
) =>
  parseInt(sale_outstanding_amount, 10) === parseInt(sale_total_amount, 10) &&
  parseInt(payment_amount, 10) < 0.25 * parseInt(sale_total_amount, 10);

export default checkMinimumPaymentAmount;
